import { SPACE_MODES } from './constants.js';

/** Chips capacité — écran 1 wizard */
export const SPACE_CAPACITY_CHIPS = [1, 4, 6, 8, 10, 12];

const DEFAULT_SPACE_UI = {
  screenTitle: 'Où se déroule l’activité ?',
  screenSubtitle: 'Sélectionnez un espace existant ou créez-en un nouveau.',
  spaceSingular: 'Espace',
  spacePlural: 'Espaces',
  newSpaceLabel: 'Nom du nouvel espace',
  newSpacePlaceholder: 'Ex. Espace principal',
  skipButtonLabel: 'Passer — espace principal',
  skipDefaultName: 'Espace principal',
  defaultCapacity: 4,
  ressourceType: 'SALLE',
  showMultiTerrainsOption: false,
  multiTerrainsLabel: 'J’ai plusieurs espaces — le client choisira à la réservation',
  multiTerrainsHelp:
    'L’activité ne sera pas liée à un seul espace. Le client choisira parmi vos espaces au moment de la réservation.',
};

const SPACE_UI_BY_CATEGORY = {
  PADEL: {
    spaceSingular: 'Terrain',
    spacePlural: 'Terrains',
    newSpaceLabel: 'Nom du nouveau terrain',
    newSpacePlaceholder: 'Ex. Terrain 1',
    skipButtonLabel: 'Passer — terrain principal',
    skipDefaultName: 'Terrain principal',
    defaultCapacity: 4,
    ressourceType: 'TERRAIN',
    showMultiTerrainsOption: true,
    multiTerrainsLabel: 'J’ai plusieurs terrains — le client choisira à la réservation',
    multiTerrainsHelp:
      'L’activité ne sera pas liée à un terrain précis. Le client choisira le terrain disponible à la réservation.',
  },
  TENNIS: {
    spaceSingular: 'Terrain',
    spacePlural: 'Terrains',
    newSpaceLabel: 'Nom du nouveau terrain',
    newSpacePlaceholder: 'Ex. Terrain 1',
    skipButtonLabel: 'Passer — terrain principal',
    skipDefaultName: 'Terrain principal',
    defaultCapacity: 4,
    ressourceType: 'TERRAIN',
    showMultiTerrainsOption: true,
    multiTerrainsLabel: 'J’ai plusieurs terrains — le client choisira à la réservation',
    multiTerrainsHelp:
      'L’activité ne sera pas liée à un terrain précis. Le client choisira le terrain disponible à la réservation.',
  },
  FOOT: {
    spaceSingular: 'Terrain',
    spacePlural: 'Terrains',
    newSpaceLabel: 'Nom du nouveau terrain',
    newSpacePlaceholder: 'Ex. Terrain 1',
    skipButtonLabel: 'Passer — terrain principal',
    skipDefaultName: 'Terrain principal',
    defaultCapacity: 12,
    ressourceType: 'TERRAIN',
    showMultiTerrainsOption: true,
    multiTerrainsLabel: 'J’ai plusieurs terrains — le client choisira à la réservation',
    multiTerrainsHelp:
      'L’activité ne sera pas liée à un terrain précis. Le client choisira le terrain disponible à la réservation.',
  },
  ESCAPE_GAME: {
    spaceSingular: 'Salle',
    spacePlural: 'Salles',
    newSpaceLabel: 'Nom de la nouvelle salle',
    newSpacePlaceholder: 'Ex. Salle Alpha',
    skipButtonLabel: 'Passer — salle principale',
    skipDefaultName: 'Salle principale',
    defaultCapacity: 6,
    ressourceType: 'SALLE',
  },
  SALLE_SPORT: {
    spaceSingular: 'Studio',
    spacePlural: 'Studios',
    newSpaceLabel: 'Nom du nouveau studio',
    newSpacePlaceholder: 'Ex. Studio Pilates',
    skipButtonLabel: 'Passer — studio principal',
    skipDefaultName: 'Studio principal',
    defaultCapacity: 6,
    ressourceType: 'SALLE',
  },
  CENTRE_EQUESTRE: {
    screenSubtitle:
      'Indiquez le manège, la carrière ou l’espace où se déroule l’activité (cours, balade, stage…).',
    spaceSingular: 'Espace',
    spacePlural: 'Espaces',
    newSpaceLabel: 'Nom de l’espace (manège, carrière…)',
    newSpacePlaceholder: 'Ex. Carrière extérieure',
    skipButtonLabel: 'Passer — espace principal',
    skipDefaultName: 'Espace principal',
    defaultCapacity: 6,
    ressourceType: 'SALLE',
  },
};

/**
 * Libellés et defaults écran 1 selon catégorie commerçant (spec Lot 0).
 * @param {string} [categorie]
 */
export function getSpaceUiConfig(categorie) {
  const key = String(categorie || '').toUpperCase();
  return { ...DEFAULT_SPACE_UI, ...(SPACE_UI_BY_CATEGORY[key] || {}) };
}

/**
 * Résumé C2 — état espace après validation écran 1.
 * @param {import('./wizardState').WizardState} state
 * @param {string} [categorie]
 * @param {Array<{ id: string, nom: string }>} [ressources]
 */
export function describeSpaceStepSummary(state, categorie, ressources = []) {
  const labels = getSpaceUiConfig(categorie);
  const { space } = state;

  if (space.mode === SPACE_MODES.MULTI) {
    const count = ressources.length;
    return {
      mode: 'multi',
      headline: 'Mode multi-espaces',
      detail: `${count} ${labels.spacePlural.toLowerCase()} disponibles — l’activité ne sera liée à aucun espace précis (ressourceId: null).`,
      ressourceId: null,
    };
  }

  const ressourceId = space.selectedRessourceId;
  const linked = ressources.find((r) => r.id === ressourceId);
  const name = linked?.nom || labels.skipDefaultName;

  return {
    mode: space.mode,
    headline: `${labels.spaceSingular} lié`,
    detail: `${labels.spaceSingular} « ${name} » sera associé à l’activité (ressourceId: ${ressourceId || '—'}).`,
    ressourceId: ressourceId || null,
  };
}
